import $ from "jquery";
import HourHelper from "./gui/hourpanel/helper";
import C from "./Constants";
import Utils from "./Utils";
import moment from "moment";

//const serverUrl = "http://10.0.0.23"; // for local testing purposes
const serverUrl = "/24-7";
//const serverUrl = "http://127.0.0.1";
//TODO RE ändern

class ServerCommunication {
    app;

    constructor(app) {
        this.app = app;
    }

    serverQueryAllGroupNames = (anonymousGroup, groupName) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {requestName: "allGroupNames"},
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    let groupNames = response.data;
                    if (anonymousGroup && groupName != null && groupName != "") {
                        groupNames = [groupName];
                    }
                    that.app.setState({groupNames: groupNames});
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverQueryGroupData = (explicitGroupName, explicitCallback) => {
        const selectedGroup = explicitGroupName == null ? this.app.state.groupData.groupName : explicitGroupName;
        if (selectedGroup !== null && selectedGroup !== undefined && selectedGroup !== "") {
            const that = this;
            const callback = explicitCallback != null ? explicitCallback : (data) => that.app.setState({groupData: data});
            $.ajax({
                url: serverUrl + "/MainServlet",
                type: "GET",
                data: {
                    requestName: "groupData",
                    groupName: selectedGroup,
                    date: this.app.state.selectedDate.format(C.inputDatePatternMoment)
                },
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    that.app.responseMessage(response.message);
                    if (!response.error) {
                        callback(response.data);
                    }
                },
                error: that.ajaxErrorCallback
            });
        }
    };

    serverQueryLoginStatus = (callback) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "loginStatus",
                autoLogin: that.app.isAutoLogin(),
                groupName: that.app.getNullableGroupName(),
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.setState({loginData: response.data}, () => {
                        if (that.app.isLoggedIn() || that.app.isAutoLogin()) {
                            that.serverQueryGroupHours();
                        } else {
                            Utils.setHourPanelViewActive(false);
                        }
                        if (callback != null) {
                            callback();
                        }
                    });
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverLoginGroupOrAdmin = (name, password, callback) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "loginGroupOrAdmin",
                name: name,
                password: password
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.setState({loginData: response.data});
                    if (!response.data.isSuperAdmin) {
                        that.serverQueryGroupData();
                    }
                    if(callback) callback(response.data.isGroupUser);
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverLoginToHourPanelView = (password, callback) => {
        const queryPassword = (password != null) ? password : "";
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "loginUser",
                groupName: this.app.state.groupData.groupName,
                password: queryPassword
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    Utils.setHourPanelViewActive(response.data.isGroupUser);
                    that.app.setState({loginData: response.data}, () => {
                        if (that.app.isLoggedIn()) {
                            that.serverQueryGroupHours();
                        }
                    });
                    if (callback) callback(response.data);
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverLogoutFromServer = () => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {requestName: "logout"},
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message, response.reason);
                if (!response.error) {
                    Utils.setHourPanelViewActive(response.data.isGroupUser);
                    that.app.setState({loginData: response.data,
                        print: {enabled: false}});
                }
            },
            error: that.ajaxErrorCallback
        })
    };

    serverQueryGroupHours = (date) => {
        const queryDate = (date != null) ? date : this.app.state.selectedDate.format(C.inputDatePatternMoment);
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "groupHours",
                groupName: that.app.state.groupData.groupName,
                autoLogin: that.app.isAutoLogin(),
                date: queryDate
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.setState({groupHours: HourHelper.combineHoursArrays(that.app.state.groupHours, response.data)}, that.app.forceUpdateGroupHours);
                }
            },
            error: that.ajaxErrorCallback
        });

        //{date: "2017.06.18", hour: "2", name: "Mama", contact: "0660 12312312", type: 0, entryNumber: 1},
    };

    serverInsertHour = (groupName, date, hour, name, contact, type, entryNumber) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "insertHour",
                groupName: groupName,
                name: name,
                contact: contact,
                date: date,
                hour: hour,
                type: type,
                entryNumber: entryNumber,
                autoLogin: true, /* that.app.isAutoLogin()*/
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.setState({groupHours: HourHelper.combineHoursArrays(that.app.state.groupHours, response.data)}, () => {
                        that.serverQueryGroupData();
                    });
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverUpdateHour = (groupName, date, hour, name, contact, type, entryNumber) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "updateHour",
                groupName: groupName,
                name: name,
                contact: contact,
                date: date,
                hour: hour,
                type: type,
                entryNumber: entryNumber
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.setState({groupHours: HourHelper.combineHoursArrays(that.app.state.groupHours, response.data)}, () => {
                        that.serverQueryGroupData();
                    });
                }
            },
            error: that.ajaxErrorCallback
        });
    };


    serverDeleteHour = (groupName, date, hour, entryNumber) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "deleteHour",
                groupName: groupName,
                entryNumber: entryNumber,
                date: date,
                hour: hour
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.state.groupHours[date + ""][hour + ""][entryNumber +""] = null;
                    that.serverQueryGroupData();
                    that.serverQueryGroupHours(date);
                }
            },
            error: that.ajaxErrorCallback
        });
    };
    deleteHourByName = (groupName, date, hour, name, contact) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "deleteHourByName",
                groupName: groupName,
                name: name,
                contact: contact,
                date: date,
                hour: hour
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.serverQueryGroupData();
                    that.serverQueryGroupHours(date);
                }
            },
            error: that.ajaxErrorCallback
        });
    };
    serverDeleteHourAllEntries = (groupName, date, hour) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "deleteHourAllEntries",
                groupName: groupName,
                date: date,
                hour: hour
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.state.groupHours[date + ""][hour + ""] = {};
                    that.serverQueryGroupData();
                    that.serverQueryGroupHours(date);
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverUpdateSuperAdmin = (name, password) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "updateSuperAdmin",
                name: name,
                password: password
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
            },
            error: that.ajaxErrorCallback
        });
    };

    serverUpdateGroup = (groupName, attribute, value, callback) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "updateGroup",
                groupName: groupName,
                attribute: attribute,
                value: value
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.serverQueryGroupData(groupName);
                    if (callback) callback();
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverDeleteGroup = (groupName) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "deleteGroup",
                groupName: groupName
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
            },
            error: that.ajaxErrorCallback
        });
    };

    serverInsertGroup = (groupName, password, adminPassword, email, contactData, hourTypes, allowedHourTypes, youtube, location) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "createGroup",
                groupName: groupName,
                password: password,
                adminPassword: adminPassword,
                email: email,
                contactData: contactData,
                hourTypes: JSON.stringify(hourTypes),
                allowedHourTypes: JSON.stringify(allowedHourTypes),
                youtube: youtube,
                location: location
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
            },
            error: that.ajaxErrorCallback
        });
    };

    serverQueryAllSuperAdmins = () => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "allSuperAdmins",
                groupName: that.app.getNullableGroupName()
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.setState({superAdmins: response.data});
                }
            },
            error: that.ajaxErrorCallback
        });
    };

    serverReportError = (error, additionalMessage) => {
        const that = this;
        let toStringOutput = null;
        try {
            toStringOutput = error.toString();
        } catch (e) {
            console.log(e)
        }
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "reportError",
                name: error.name,
                message: error.message,
                description: error.description,
                fileName: error.fileName,
                lineNumber: error.lineNumber,
                columnNumber: error.columnNumber,
                number: error.number,
                stack: error.stack,
                toStringOutput: toStringOutput,
                additionalMessage: additionalMessage,
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (response.error) {
                    console.log("failed to report exception: " + error)
                }
            },
            error: that.ajaxErrorCallback
        });
    }

    serverReportMessage = (errorMessage) => {
        console.log("Reporting error <" + errorMessage + ">")
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "reportMessage",
                errorMessage: errorMessage
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (response.error) {
                    console.log("failed to report errorMessage: " + errorMessage)
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log("An error occurred in the server communication");
                console.log(textStatus + " - " + errorThrown + " at <" + jqXHR + ">");
            }
        });
    }


    ajaxErrorCallback = (jqXHR, textStatus, errorThrown) => {
        this.serverReportMessage(textStatus + " - " + errorThrown + " at <" + jqXHR + ">");
    }

    serverOldWeekName = (weekName) => {
        const that = this;
        $.ajax({
            url: serverUrl + "/MainServlet",
            type: "GET",
            data: {
                requestName: "oldWeekName",
                weekName: weekName
            },
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                that.app.responseMessage(response.message);
                if (!response.error) {
                    that.app.changeGroupName(response.data.groupName);
                    that.app.changeSelectedDate(moment(response.data.date, C.inputDatePatternMoment));
                }
            }
        });
    };



}

export default ServerCommunication;
